import { render, staticRenderFns } from "./RegisterCar.vue?vue&type=template&id=bd37a9c4&scoped=true"
import script from "./RegisterCar.vue?vue&type=script&lang=js"
export * from "./RegisterCar.vue?vue&type=script&lang=js"
import style0 from "./RegisterCar.vue?vue&type=style&index=0&id=bd37a9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd37a9c4",
  null
  
)

export default component.exports